import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import EditUserDialog from "./EditAuthorizationDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { statusEnergy, typeAuthorization, authorizationStatus } from "variables/lists/authorization";
import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  NotificationManager,
} from "react-notifications";
import { compte } from "variables/patrimoine.js";


import { getAPIAuthorizationList, deleteAPIAuthorization, getFileName, downloadFile } from "services/ConfigServices";

//import "react-table/react-table.css";

// @mui/icons-material
import Edit from "@mui/icons-material/Edit";

//import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import moment from "moment";


const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const useStyles2 = makeStyles((theme) => ({
  root: {
    margin: "0 0 0 -8px",
    "& > *": {
      margin: '8px',
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  chip: {
    margin: '4px',
  },
}));

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontSize: '0.9375rem',
    marginLeft: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementDataDownload = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const ExpandableComponent = props => {
  const { data } = props;
  const [value, setValue] = useState(0);
  const [fileName, setFileName] = useState("");

  const classes = useStyles2();

  function handleSubMenuChange(value) {
    setValue(value);
  }

  const downloadGED = (idSelected) => async () => {
    axios
      .get(
        downloadFile(idSelected),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  const getRowFileName = (fileid) => {
    axios
      .get(
        getFileName(fileid),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setFileName(res.data.filename);
        }
        else if (res.status == 204) {
          setFileName("unfound");
        }
      });
  }


  const SubTabs = () => {
    if (fileName === "")
      getRowFileName(data.associatedfile);
    return (
      <>
        <div>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.datebegin} : </ElementTitle>
            <ElementData>{data.datebegin}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.dateend} : </ElementTitle>
            <ElementData>{data.dateend}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.associatedfile} : </ElementTitle>
            {fileName === 'unfound' ?
              <ElementData>Fichier non trouvé</ElementData> :
              <ElementDataDownload onClick={downloadGED(data.associatedfile)}>{fileName}</ElementDataDownload>
            }
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.comment} : </ElementTitle>
            <ElementData>{data.comment}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.firstname} : </ElementTitle>
            <ElementData>{data.firstname}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.lastname} : </ElementTitle>
            <ElementData>{data.lastname}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.email} : </ElementTitle>
            <ElementData>{data.email}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.authorization.postalcode} : </ElementTitle>
            <ElementData>{data.postalcode}</ElementData>
          </ExpandableElement>
          {
            (data.type === 'engiebilleelectricity' || data.type === 'engiebillegas') &&
            <>
              <ExpandableElement>
                <ElementTitle>{compte.authorization.apiaccountmail} : </ElementTitle>
                <ElementData>{data.otherdata?.apiaccountmail}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>{compte.authorization.apisecretkey} : </ElementTitle>
                <ElementData>{data.otherdata?.apisecretkey ? 'Oui' : 'Non'}</ElementData>
              </ExpandableElement>
            </>
          }
          {
            (data.type === 'gdbftpgas') &&
            <>
              <ExpandableElement>
                <ElementTitle>{compte.authorization.ftpdirectory} : </ElementTitle>
                <ElementData>{data.otherdata?.ftpdirectory}</ElementData>
              </ExpandableElement>
            </>
          }
        </div>
      </>

    );

  };

  return (
    <Container>
      <ExpandableContainer>
        <div>
          <SubTabs />
        </div>
      </ExpandableContainer>
    </Container>
  );
};

const RTAuthorization = () => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { gridState, refreshTable, setLoading } = useEntitesTable();

  const [open, setOpen] = useState(false);
  const [openEditFiles, setOpenEditFiles] = useState(false);

  const [prevAuthorizationList, setPrevAuthorizationList] = useState();
  const [type, setType] = useState("");
  const [id, setId] = useState("");
  const [energy, setEnergy] = useState("");
  const [metersDso, setMetersDso] = useState("");
  const [legalname, setLegalname] = useState("");
  const [datebegin, setDatebegin] = useState("");
  const [dateend, setDateend] = useState("");
  const [ged, setGed] = useState([]);
  const [verified, setVerified] = useState("");
  const [comment, setComment] = useState();
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [postalcode, setPostalcode] = useState("");
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const [otherdata, setOtherdata] = useState({});

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };
  const handleEnergyChange = (e) => {
    setEnergy(e.target.value);
  };
  const handleDsoChange = (e) => {
    setMetersDso(e.target.value);
  };
  const handleLegalnameChange = (e) => {
    setLegalname(e.target.value);
  };
  const handleDatebeginChange = (e) => {
    setDatebegin(e.target.value);
  };
  const handleDateendChange = (e) => {
    setDateend(e.target.value);
  };
  const handleAssociatedfilesChange = (newValue) => {
    if (newValue)
      setGed(newValue.fileId);
    else
      setGed("");
  };
  const handleVerifiedChange = (e) => {
    setVerified(e.target.value);
  };
  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };
  const handleFirstnameChange = (e) => {
    setFirstname(e.target.value);
  };
  const handleLastnameChange = (e) => {
    setLastname(e.target.value);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePostalcodeChange = (e) => {
    setPostalcode(e.target.value);
  };

  const handleApiaccountmailChange = (e) => {
    let otherdataobj = { ...otherdata };
    otherdataobj.apiaccountmail = e.target.value;
    setOtherdata(otherdataobj);
  };
  const handleApisecretkeyChange = (e) => {
    let otherdataobj = { ...otherdata };
    otherdataobj.apisecretkey = e.target.value;
    setOtherdata(otherdataobj);
  };
  const handleFtpdirectoryChange = (e) => {
    let otherdataobj = { ...otherdata };
    otherdataobj.ftpdirectory = e.target.value;
    setOtherdata(otherdataobj);
  };
  const handleDsochoruscodeChange = (e) => {
    let otherdataobj = { ...otherdata };
    otherdataobj.dsochoruscode = e.target.value;
    setOtherdata(otherdataobj);
  };
  const handleDsofiletemplateChange = (e) => {
    let otherdataobj = { ...otherdata };
    otherdataobj.dsofiletemplate = e.target.value;
    setOtherdata(otherdataobj);
  };
  const handleGetAttachedFileChange = (e) => {
    let otherdataobj = { ...otherdata };
    otherdataobj.getAttachedFile = otherdataobj.getAttachedFile ? !otherdataobj.getAttachedFile : true;
    setOtherdata(otherdataobj);
  };
  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  let dataUsers = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      name: compte.authorization.type,
      selector: row => row.type,
      sortable: true,
      cell: (row) =>
        <div>{row.type ? typeAuthorization.find((x) => x.id == row.type)?.name : ''}</div>
    }, {
      name: compte.authorization.energy,
      selector: row => row.energy,
      sortable: true,
      cell: (row) =>
        <div>{statusEnergy.find((x) => x.id == row.energy).name}</div>
    },
    {
      name: compte.authorization.dso,
      selector: row => row.dso,
      sortable: true,
    },
    {
      name: compte.authorization.legalname,
      selector: row => row.legalname,
      sortable: true,
      cell: (row) =>
        chartIdGroup == '22848' ? <>Compte de démo</> : <>{row.legalname}</> //for demo account
    },
    {
      name: compte.authorization.dateend,
      selector: row => row.dateend,
      sortable: true,
      cell: (row) =>
        moment(row.dateend).isAfter(moment()) ?
          <>{row.dateend}</> : <div style={{ color: '#C53F3F', fontWeight: "bold" }}>
            {row.dateend}
          </div>
    },
    {
      name: compte.authorization.verified,
      selector: row => row.verified,
      sortable: true,
      maxWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) =>
        moment(row.dateend).isAfter(moment()) ?
          <div style={{ color: authorizationStatus.find((x) => x.id == row.verified).color, fontWeight: "bold" }}>
            {authorizationStatus.find((x) => x.id == row.verified).name}
          </div> :
          <div style={{ color: '#C53F3F', fontWeight: "bold" }}>
            Périmée
          </div>
    },
    realestateupdate ?
      {
        name: "Actions",
        sortable: true,
        width: "8rem",
        // eslint-disable-next-line react/display-name
        cell: (row) => (
          <>
            <div className="actions-right">
              <Button
                color={"success"}
                className={classes.actionButton}
                onClick={editAuthorization(row)}
              >
                <Edit className={classes.icon} />
              </Button>
              <CustomDeleteButton
                deleteTitle={"Suppression de l'autorisation"}
                deleteSubTitle={
                  "Êtes-vous sûr de vouloir supprimer l'autorisation ?"
                }
                handleSupprimer={deleteUser(row)}
              />
            </div>
          </>
        ),
      } : {},
  ];

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  useEffect(() => {
    axios
      .get(
        getAPIAuthorizationList(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevAuthorizationList(
          res.data.authorizations || []
        );
      });
  }, []);

  const editAuthorization = (row) => async () => {
    let obj = dataUsers.find((o) => o.id === row.id);
    handleClickOpen();
    setType(obj.type);
    setId(obj.id);
    setEnergy(obj.energy);
    setMetersDso(obj.dso);
    setLegalname(obj.legalname);
    setDatebegin(obj.datebegin);
    setDateend(obj.dateend);
    setGed(obj.associatedfile);
    setVerified(obj.verified);
    setComment(obj.comment);
    setFirstname(obj.firstname);
    setLastname(obj.lastname);
    setEmail(obj.email);
    setPostalcode(obj.postalcode);
    setOtherdata(obj.otherdata || {});
  };

  const deleteUser = (row) => async () => {
    let obj = dataUsers.find((o) => o.id === row.id);
    let idSelected = obj.id;

    axios
      .delete(
        deleteAPIAuthorization(idSelected), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
      )
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success("L'autorisation a bien été supprimée");
        else NotificationManager.error("Un problème est survenu");
        refreshTable();
      })
      .catch(() => { });
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>Aucune autorisation à afficher</NoData>}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={updateState}
          expandOnRowClicked
          expandableRows
          expandableRowDisabled={(row) => row.disabled}
          expandableRowsComponent={ExpandableComponent}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          paginationComponentOptions={
            {
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes"
            }
          }
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            Modifier l'autorisation
          </DialogTitle>
          <DialogContent dividers>
            <EditUserDialog
              setLoading={setLoading}
              setNotification={setNotification}
              closeModal={handleClose}
              refetch={refreshTable}
              authorizationId={id}
              energy={energy}
              metersDso={metersDso}
              legalname={legalname}
              datebegin={datebegin}
              dateend={dateend}
              ged={ged}
              verified={verified}
              comment={comment}
              firstname={firstname}
              lastname={lastname}
              email={email}
              postalcode={postalcode}
              otherdata={otherdata}
              type={type}
              handleApisecretkeyChange={handleApisecretkeyChange}
              handleApiaccountmailChange={handleApiaccountmailChange}
              handleTypeChange={handleTypeChange}
              handleEnergyChange={handleEnergyChange}
              handleDsoChange={handleDsoChange}
              handleLegalnameChange={handleLegalnameChange}
              handleDatebeginChange={handleDatebeginChange}
              handleDateendChange={handleDateendChange}
              handleAssociatedfilesChange={handleAssociatedfilesChange}
              handleVerifiedChange={handleVerifiedChange}
              handleCommentChange={handleCommentChange}
              handleFirstnameChange={handleFirstnameChange}
              handleLastnameChange={handleLastnameChange}
              handleEmailChange={handleEmailChange}
              handlePostalcodeChange={handlePostalcodeChange}
              handleFtpdirectoryChange={handleFtpdirectoryChange}
              handleDsochoruscodeChange={handleDsochoruscodeChange}
              handleDsofiletemplateChange={handleDsofiletemplateChange}
              handleGetAttachedFileChange={handleGetAttachedFileChange}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>

    </>
  );
};

export default RTAuthorization;
